module.exports = __webpack_public_path__ + "img/hm.9a095a09.svg";